<div class="flex justify-between bg-card">
    <span>hello</span>
    <!-- <form [formGroup]="form">
        <formly-form
            [model]="model"
            [fields]="fields"
            [form]="form"
        ></formly-form>
    </form> -->
</div>
